import { type ClassValue, defaultConfig, cn as tailwindVariantsCn, tv, type VariantProps } from 'tailwind-variants';

function cn(...inputs: ClassValue[]) {
	return tailwindVariantsCn(...inputs)(defaultConfig);
}

export { cn, tv };
export type { ClassValue, VariantProps };
